import { Skeleton } from '@/components/ui/skeleton';
import { useTrackingData } from '@/services/tracking.service';
import BackofficePage, {
    DataCard,
    DataTable,
    TH,
    TR,
    TD,
} from '../../components/BackofficePage';

// Column labels: current week (W) then W-1 … W-10, matching weeks[] index order.
const WEEK_LABELS = ['W', ...Array.from({ length: 10 }, (_, i) => `W-${i + 1}`)];

export default function BackOfficeTracking() {
    const { data: users, isLoading, error } = useTrackingData();

    if (isLoading)
        return (
            <BackofficePage title="Tracking" description="Loading…">
                <Skeleton className="w-full h-[400px] bg-[#1e242a]" />
            </BackofficePage>
        );
    if (error)
        return (
            <BackofficePage title="Tracking" description="Error">
                <div className="text-red-400 text-sm">{error.toString()}</div>
            </BackofficePage>
        );

    return (
        <BackofficePage
            title="Tracking"
            description="Weekly activity by user — current week and the previous ten."
        >
            <DataCard>
                <DataTable>
                    <thead className="bg-[#0f141a]">
                        <tr>
                            <TH>User</TH>
                            {WEEK_LABELS.map((label) => (
                                <TH key={label} align="center">
                                    {label}
                                </TH>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {users?.data?.map((userData, index) => (
                            <TR key={index}>
                                <TD>
                                    {userData.user.firstName}{' '}
                                    {userData.user.lastName}
                                </TD>
                                {WEEK_LABELS.map((label, week) => (
                                    <ActivityCell
                                        key={label}
                                        value={userData.weeks?.[week]}
                                    />
                                ))}
                            </TR>
                        ))}
                    </tbody>
                </DataTable>
            </DataCard>
        </BackofficePage>
    );
}

function ActivityCell({ value }: { value: number | undefined | null }) {
    const v = value ?? 0;
    return (
        <TD align="center">
            <span
                className={`tabular-nums ${
                    v === 0
                        ? 'text-[#6b7480]'
                        : v > 5
                          ? 'text-[#74c69d] font-medium'
                          : 'text-[#d8dde2]'
                }`}
            >
                {v}
            </span>
        </TD>
    );
}
